import { z } from 'zod';

export const PAGE_MEMO_REACTION_EMOJIS = [
  '👍',
  '👀',
  '✅',
  '❗',
  '💡',
  '❓',
] as const;

export const PageMemoReactionEmojiSchema = z.enum(PAGE_MEMO_REACTION_EMOJIS);
export type PageMemoReactionEmoji = z.infer<typeof PageMemoReactionEmojiSchema>;

export const PageMemoCommonSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  pageKey: z.string(),
  content: z.string(),
  createdBy: z.string().uuid().nullable().optional(),
  updatedBy: z.string().uuid().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type PageMemoCommon = z.infer<typeof PageMemoCommonSchema>;

export const PageMemoPersonalSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  userId: z.string().uuid(),
  pageKey: z.string(),
  content: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type PageMemoPersonal = z.infer<typeof PageMemoPersonalSchema>;

export const PageMemoUserSchema = z.object({
  id: z.string().uuid(),
  name: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  avatarUrl: z.string().nullable().optional(),
});
export type PageMemoUser = z.infer<typeof PageMemoUserSchema>;

export const PageMemoCommentSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  pageKey: z.string(),
  userId: z.string().uuid(),
  content: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable().optional(),
  deletedBy: z.string().uuid().nullable().optional(),
  user: PageMemoUserSchema.optional(),
});
export type PageMemoComment = z.infer<typeof PageMemoCommentSchema>;

export const PageMemoReactionSummarySchema = z.object({
  emoji: PageMemoReactionEmojiSchema,
  count: z.number(),
  users: z.array(PageMemoUserSchema),
});
export type PageMemoReactionSummary = z.infer<typeof PageMemoReactionSummarySchema>;

export const PageMemoReactionCountSchema = z.object({
  emoji: PageMemoReactionEmojiSchema,
  count: z.number(),
});
export type PageMemoReactionCount = z.infer<typeof PageMemoReactionCountSchema>;

export const PageMemoSummarySchema = z.object({
  pageKey: z.string(),
  hasCommonMemo: z.boolean(),
  commonUpdatedAt: z.coerce.date().nullable(),
  hasPersonalMemo: z.boolean(),
  personalUpdatedAt: z.coerce.date().nullable(),
  commentCount: z.number(),
  reactionCount: z.number(),
  reactions: z.array(PageMemoReactionCountSchema),
});
export type PageMemoSummary = z.infer<typeof PageMemoSummarySchema>;

export const PageMemoBundleSchema = z.object({
  pageKey: z.string(),
  commonMemo: PageMemoCommonSchema.nullable(),
  personalMemo: PageMemoPersonalSchema.nullable(),
  comments: z.array(PageMemoCommentSchema),
  reactions: z.array(PageMemoReactionSummarySchema),
});
export type PageMemoBundle = z.infer<typeof PageMemoBundleSchema>;

export const PageMemoKeySchema = z.string().min(1).max(200);

export const UpsertPageMemoInputSchema = z.object({
  pageKey: PageMemoKeySchema,
  content: z.string(),
});
export type UpsertPageMemoInput = z.infer<typeof UpsertPageMemoInputSchema>;

export const CreatePageMemoCommentInputSchema = z.object({
  pageKey: PageMemoKeySchema,
  content: z.string().min(1, 'コメントを入力してください'),
});
export type CreatePageMemoCommentInput = z.infer<typeof CreatePageMemoCommentInputSchema>;

export const UpdatePageMemoCommentInputSchema = z.object({
  commentId: z.string().uuid(),
  content: z.string().min(1, 'コメントを入力してください'),
});
export type UpdatePageMemoCommentInput = z.infer<typeof UpdatePageMemoCommentInputSchema>;

export const TogglePageMemoReactionInputSchema = z.object({
  pageKey: PageMemoKeySchema,
  emoji: PageMemoReactionEmojiSchema,
});
export type TogglePageMemoReactionInput = z.infer<typeof TogglePageMemoReactionInputSchema>;


